import { SocialMediaPosting } from 'schema-dts';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { useTranslation } from 'react-i18next';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { ArticleDetailUtil } from 'shared/models';
import { $CurrentArticleGPTInfo } from '../../shared/atoms/current-article-gpt-info';
import { $HitArticleGptTDK } from '~/utils/libra/article-gpt-tdk';

export const useArticleBaseJsonLD = (): SocialMediaPosting | null => {
  const { t } = useTranslation();
  const { region } = useAtomValue($Locale);
  const article = useAtomValue($CurrentAvailableArticleOrNull);

  const gptInfo = useAtomValue($CurrentArticleGPTInfo);
  const hitArticleGptTDK = useAtomValue($HitArticleGptTDK);

  const abInfo = { hitArticleGptTDK };

  if (!article) {
    return null;
  }

  return ArticleDetailUtil.JsonLD.getSocialMediaJsonLD({
    article,
    region,
    t,
    abInfo,
    gptInfo,
  });
};
